var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Column } from '../../models';
import { TopicService, TopicV2Service, ViewService } from '../../services';
import { SearchView } from '../../interfaces';
import { ShortDatePipe, TopicTypePipe } from '../../pipes';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap';
import { RecipientsListModal } from '../../widgets/recipients-list-modal/recipients-list-modal';
var TopicsComponent = /** @class */ (function (_super) {
    __extends(TopicsComponent, _super);
    function TopicsComponent(viewService, route, service, translatePipe, modalService, topicV2Service) {
        var _this = _super.call(this, viewService, route, service, 'topics', 'topic') || this;
        _this.modalService = modalService;
        _this.topicV2Service = topicV2Service;
        _this.today = moment().startOf('day').valueOf();
        _this.selectedAuthors = [];
        _this.selectedStudents = [];
        _this.searchAuthors = function (text) { return _this.topicV2Service.autocompleteAuthors(text)
            .map(function (items) { return items.map(function (item) { return new IdNamePair(item._id, item.label); }); }); };
        _this.searchStudents = function (text) { return _this.topicV2Service.autocompleteStudents(text)
            .map(function (items) { return items.map(function (item) { return new IdNamePair(item._id, item.label); }); }); };
        _this.showAuthorFilter = !viewService.hasUserRole('teacher');
        // default sort
        _this.params.sort = { dateTime: -1 };
        _this.params.conditions.type = {
            $in: TopicService.TOPIC_COMPONENT_TYPES
        };
        _this.topicTypes = _this.viewService.optionalList(TopicService.TOPIC_COMPONENT_TYPES, undefined);
        var shortDatePipe = new ShortDatePipe();
        shortDatePipe.locale = viewService.auth.getCurrentUser().locale;
        _this.columns = [
            _this.routerColumn('date', 'TOPIC.DATE', {
                isPrimary: true,
                minWidth: 90,
                maxWidth: 90,
                pipe: shortDatePipe
            }),
            Column.forClick('type', 'TOPIC.TYPE', _this.onSelect.bind(_this), true, new TopicTypePipe(translatePipe), 90, 90, 'defaultLabelCell'),
            _this.routerColumn('title', 'TOPIC.TITLE', { isPrimary: true }),
            new Column('recipients', 'TOPIC.RECIPIENTS', false, undefined, 'topicRecipientsCell', undefined, undefined, undefined, function (topic) {
                _this.openModal(topic);
            }),
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
            new Column('audience', 'TOPIC.AUDIENCE', false, null, 'topicAudienceCell', 120, 120),
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
            new Column('attachments.length', 'TOPIC.ATTACHMENTS', false, null, 'defaultBadgeCell', 80, 80),
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
            new Column('resolvedName', 'TOPIC.AUTHOR', false, null)
        ];
        return _this;
    }
    TopicsComponent.prototype.ngOnInit = function () {
        var _a;
        // Supervisors/owners/employees have ANY_TOPICS, so v2 returns the whole stage. Start scoped
        // to their own comunicados by preselecting themselves in the author filter; the chip can be
        // removed to see everyone's. Teachers lack ANY_TOPICS: v2 always scopes them server side, so
        // the filter is hidden and there is nothing to seed.
        if (this.showAuthorFilter) {
            var user = this.viewService.getCurrentUser();
            this.selectedAuthors = [new IdNamePair(user._id, (_a = this.fullName(user.name)) !== null && _a !== void 0 ? _a : user._id)];
            this.setAuthorsFilter(this.selectedAuthors);
        }
        _super.prototype.ngOnInit.call(this);
    };
    TopicsComponent.prototype.setAuthorsFilter = function (idNamePairs) {
        this.params.conditions.createdBy = idNamePairs.map(function (e) { return e.id; });
        this.updateFilter();
    };
    TopicsComponent.prototype.setStudentsFilter = function (idNamePairs) {
        this.params.conditions.students = idNamePairs.map(function (e) { return e.id; });
        this.updateFilter();
    };
    TopicsComponent.prototype.onStartDateChange = function (timestamp) {
        if (!this.params.conditions.timestamp) {
            this.params.conditions.timestamp = {};
        }
        this.params.conditions.timestamp['$gt'] = timestamp;
        this.updateFilter();
    };
    TopicsComponent.prototype.onEndDateChange = function (timestamp) {
        if (!this.params.conditions.timestamp) {
            this.params.conditions.timestamp = {};
        }
        this.params.conditions.timestamp['$lt'] = timestamp;
        this.updateFilter();
    };
    TopicsComponent.prototype.updateTopicFilter = function () {
        if (this.selectedTopic === undefined) {
            this.params.conditions.type.$in = TopicService.TOPIC_COMPONENT_TYPES;
        }
        else {
            this.params.conditions.type.$in = [this.selectedTopic];
        }
        this.updateFilter();
    };
    // The list is served by the v2 API; the detail page and the recipients modal still use
    // the legacy endpoints through TopicService.
    TopicsComponent.prototype.fetch = function (params) {
        return this.topicV2Service.search(params);
    };
    TopicsComponent.prototype.onDataFetched = function (data) {
        var _this = this;
        data.list.forEach(function (e) {
            var _a;
            // v2 returns createdBy populated with { _id, name }, so the name comes straight from
            // the row; the legacy id (or an author without a name) is used as a fallback
            var populated = typeof e.createdBy === 'string' ? undefined : e.createdBy;
            // @ts-ignore
            e.resolvedName = (_a = _this.fullName(populated && populated.name)) !== null && _a !== void 0 ? _a : (populated ? populated._id : e.createdBy);
        });
        _super.prototype.onDataFetched.call(this, data);
    };
    TopicsComponent.prototype.openModal = function (topic) {
        this.modalRef = this.modalService.show(RecipientsListModal, { initialState: { topic: topic }, class: 'modal-lg' });
    };
    TopicsComponent.prototype.fullName = function (name) {
        var _a;
        if (!name) {
            return undefined;
        }
        return (_a = name.full) !== null && _a !== void 0 ? _a : (name.last + ', ' + name.first);
    };
    return TopicsComponent;
}(SearchView));
export { TopicsComponent };
var IdNamePair = /** @class */ (function () {
    function IdNamePair(id, name) {
        this.id = id;
        this.name = name;
    }
    return IdNamePair;
}());
